import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { getWorkCalendarWorkTimeSaldoInformationInTimeframe } from 'scenes/WorkDemo/services/getWorkCalendarWorkTimeSaldoInformationInTimeframe.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const loadWorkCalendarWorkTimeSaldoInformationInTimeframe =
  createAsyncThunk(
    'recordAllowances/loadWorkCalendarWorkTimeSaldoInformationInTimeframe',
    async (_, { getState }) => {
      const selectedProjectId = selectSelectedProjectId(getState());
      const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

      const { workSearchParams_demo } = getState();

      const fromDate = dayjs(workSearchParams_demo.fromDate).format(
        'YYYY-MM-DD'
      );
      const toDate = dayjs(workSearchParams_demo.toDate).format('YYYY-MM-DD');

      const response = await getWorkCalendarWorkTimeSaldoInformationInTimeframe(
        selectedProjectId,
        { fromDate, toDate },
        activeEmployerInfo
      );
      return response;
    }
  );
